import { EditorConfig, isHTMLAnchorElement } from 'lexical';
import { LinkNode, SerializedLinkNode } from '@lexical/link';
import { getUrlTarget } from '@mutiny-pkg/bin-ui/src/utils/url';

export type SerializedCustomLinkNode = SerializedLinkNode;

export class CustomLinkNode extends LinkNode {
  static getType(): string {
    return 'custom-link';
  }

  static clone(node: CustomLinkNode): CustomLinkNode {
    return new CustomLinkNode(
      node.getURL(),
      { rel: node.__rel, target: node.__target, title: node.__title },
      node.__key,
    );
  }

  static importJSON(serializedNode: SerializedCustomLinkNode): CustomLinkNode {
    return new CustomLinkNode(serializedNode.url);
  }

  createDOM(config: EditorConfig): HTMLAnchorElement | HTMLSpanElement {
    const anchor = super.createDOM(config);
    if (isHTMLAnchorElement(anchor)) {
      const target = getUrlTarget(this.__url);
      if (target) anchor.target = target;
    }
    return anchor;
  }

  exportJSON(): SerializedCustomLinkNode {
    return {
      ...super.exportJSON(),
      type: 'custom-link',
    };
  }
}
